@for (items of data; track items; let index = $index) {
  <ul
    [style.listStyle]="
      items && items.length > 0 && items[0]?.listStyle
        ? items[0]?.listStyle
        : 'disc'
    "
    class="{{ items[0]?.listStyle === 'none' ? 'ps-0' : '' }} mb-0">
    <li id="listItem_{{ index }}" class="py-2">
      @for (item of items; track item) {
        <span class="list-item d-inline">
          @if (!item.url && !item.isClickable) {
            <span ngClass="mb-0 {{ item.styleClass }}">
              {{ item.item }}
            </span>
          }
          @if (item.isClickable) {
            <span
              ngClass="mb-0 act-as-link {{ item.styleClass }}"
              id="listWithLink_{{ index }}"
              (click)="linkClick(item)">
              {{ item.item }}
            </span>
          }
          @if (item.url) {
            <a
              ngClass="link {{ item.styleClass }}"
              href="{{ item.url }}"
              target="{{ item.target }}"
              >{{ item.item }}</a
            >
          }
        </span>
      }
    </li>
  </ul>
}
